import { apolloClient } from "../../../src/graphql/apolloClient";
import { GROWTH_PROJECTIONS_BULK_QUERY } from "../../../src/pages/rankings/growthProjections/growthProjectionsPressRelease/useGrowthProjectionsData";
import { CPProductClass } from "../../../src/types/countryProfileEnums";
import RankingsLayout from "../../../src/pages/rankings/RankingsLayout";
import { buildMeta } from "../../routeMeta";

export async function clientLoader() {
  await apolloClient.query({
    query: GROWTH_PROJECTIONS_BULK_QUERY,
    variables: { productClass: CPProductClass.HS12 },
    fetchPolicy: "cache-first",
  });
  return null;
}
clientLoader.hydrate = false as const;

export function meta(args) {
  return buildMeta(
    {
      title: "Growth Projections — The Atlas of Economic Complexity",
      description:
        "Press release and findings from the Growth Lab's annual Growth Projections.",
      ogImage: "share_growth_projections.png",
    },
    args,
  );
}

export default RankingsLayout;
